type CamelToSnakeCase<S extends string> = S extends `${infer T}${infer U}`
	? U extends Uncapitalize<U>
		? `${Lowercase<T>}${CamelToSnakeCase<U>}`
		: `${Lowercase<T>}_${CamelToSnakeCase<Uncapitalize<U>>}`
	: S;

type TransformKeysToSnakeCase<T> = {
	[K in keyof T as CamelToSnakeCase<Extract<K, string>>]: T[K] extends object
		? T[K] extends Array<any>
			? T[K]
			: TransformKeysToSnakeCase<T[K]>
		: T[K];
};

function camelToSnake(str: string): string {
	return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function transformKeysToSnakeCase<T extends Record<string, any>>(
	obj: T,
): TransformKeysToSnakeCase<T> {
	if (Array.isArray(obj)) {
		return obj.map((item) => transformKeysToSnakeCase(item)) as any;
	}
	if (obj !== null && typeof obj === "object") {
		const result: any = {};
		for (const key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				const newKey = camelToSnake(key);
				const value = obj[key];
				result[newKey] = transformKeysToSnakeCase(value);
			}
		}
		return result;
	}
	return obj as any;
}
